// db.js
import Dexie from "dexie";

export const db = new Dexie("offlineProcastStores");
db.version(1).stores({
  procastStores:
    "++id,   timestamp, store_date, store_name, street_name, barangay, city, remarks, latitude2, longitude2, address2, agent_visit, poster_priority_1, poster_priority_2, flyer, is_poster_priority_1, is_poster_priority_2, is_flyer, trade_letter, address1, latitude1, longitude1, selling_illicit_cigar, qr_code, store_image, reason_image, cigar_arr", // Primary key and indexed props
});
